import axios from 'axios';
import qs from 'qs';

export const getColorMatchLessonById = ({
  lessonId,
  locale,
}: {
  lessonId: string;
  locale?: string;
}) =>
  axios.get(
    `/api/v1/color-match-lessons/${lessonId}${locale ? `?${qs.stringify({ locale })}` : ''}`,
  );

export const createColorMatchLesson = (data: any) =>
  axios.post('/api/v1/color-match-lessons', data);

export const updateColorMatchLessonById = ({
  lessonId,
  data,
}: {
  lessonId: string;
  data: any;
}) => axios.put(`/api/v1/color-match-lessons/${lessonId}`, data);

export const removeColorMatchLessonById = (lessonId: string) =>
  axios.delete(`/api/v1/color-match-lessons/${lessonId}`);
